/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backgrid from 'backgrid';

import tmplListCell from './ListCell.hbs';

const ListCell = Backgrid.Cell.extend({
  className: 'list-cell',

  render() {
    const cellValue = this.model.get(this.column.get('name'));
    const template = this.column.get('listTemplate') ? this.column.get('listTemplate') : tmplListCell;
    const emptyText = this.column.get('emptyText') ? this.column.get('emptyText') : '--';
    const content = template({
      values: cellValue,
      emptyText,
    });
    this.$el.empty().append(content);
    this.$el.addClass(this.column.get('name'));
    this.delegateEvents();
    return this;
  },
});

export default ListCell;
